import { useEffect, useRef, type RefObject } from "react";

import { scrollActiveCardIntoView } from "../scrollbarUtils";

export const useScrollActiveCardIntoView = (
  scrollRef: RefObject<HTMLDivElement | null>,
  activeId: string
): void => {
  const skipInitialScrollRef = useRef(true);

  useEffect(() => {
    if (skipInitialScrollRef.current) {
      skipInitialScrollRef.current = false;
      return;
    }

    const scrollElement = scrollRef.current;
    if (!scrollElement) {
      return;
    }

    scrollActiveCardIntoView(scrollElement, activeId);
  }, [activeId, scrollRef]);
};
